export const CARD_CLASS =
  'rounded-[10px] border border-solid border-[#00000020] bg-prompt-safecomfantasy shadow-[0px_2px_4px_#0000001a]';

export const INSET_CLASS =
  'rounded-lg border border-[#00000014] bg-prompt-safecomwhite';

export const DEFAULT_BUDGET_DOLLARS = '2';
export const MAX_BUDGET_DOLLARS = 1000;

export const MANAGED_AGENTS_DOCS_URL =
  'https://platform.claude.com/docs/en/managed-agents/overview';
export const ANTHROPIC_KEYS_URL = 'https://platform.claude.com/settings/keys';
